import helpStyles from "../styles/help.css?url";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { withStylesheet } from "./head";

/** Route heads stay free of article components and the server-only help corpus. */
export function helpHead(
  matches: readonly { loaderData?: unknown; routeId: string }[],
  page: { path: string; title: string; description: string; query?: string } | undefined,
) {
  return page
    ? withStylesheet(
        platformPageHead(platformShellFrom(matches), {
          pathname: page.path,
          title: `${page.title} | Drate Help`,
          description: page.description,
          canonicalPath: page.path,
          noindex: Boolean(page.query),
        }),
        helpStyles,
      )
    : {};
}
